import { render, staticRenderFns } from "./CertificationInfo.vue?vue&type=template&id=2ae00a97&scoped=true&"
import script from "./CertificationInfo.vue?vue&type=script&lang=js&"
export * from "./CertificationInfo.vue?vue&type=script&lang=js&"
import style0 from "./CertificationInfo.vue?vue&type=style&index=0&id=2ae00a97&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae00a97",
  null
  
)

export default component.exports